<ng-template #closeButtonRef>
  <img
    src="/assets/svg/ico-hamburger-close.svg"
    class="cross-button pointer-cursor"
    (click)="closeDialog()"
  />
</ng-template>

<ng-container *ngIf="stepper === 1">
  <app-multi-user-selection-list
    [users]="users"
    [(stepper)]="stepper"
    [selectedUsers]="selectedUsers"
    (submitSelectedUsers)="submitSelectedUsers($event)"
    [isDashboard]="isDashboard"
    [(userType)]="userType"
    (submitToParent)="submitToParent($event)"
  >
  </app-multi-user-selection-list>
</ng-container>
<ng-container *ngIf="stepper === 2">
  <app-multi-user-type
    [userType]="userType"
    [(stepper)]="stepper"
    [(userType)]="userType"
    (submitToParent)="submitToParent($event)"
  >
    <span closeButton>
      <ng-template [ngTemplateOutlet]="closeButtonRef"></ng-template>
    </span>
  </app-multi-user-type>
</ng-container>
<ng-container *ngIf="stepper === 3">
  <app-multi-user-access-time
    formGroupName="accessTime"
    [selectedGroup]="user"
    [dialogRef]="dialogRef"
    [(stepper)]="stepper"
    (submitToParent)="submitToParent($event)"
    [siteTimeZone]="siteTimeZone"
  >
    <span closeButton>
      <ng-template [ngTemplateOutlet]="closeButtonRef"></ng-template>
    </span>
  </app-multi-user-access-time>
</ng-container>
